<template>
    <setup_content title="Расчет прибыли предпринимателя">

        <setup_frame v-if="data" title="Расчет нормы доходности для инвестиций в строительство">
            <div class="element-row mb-3">
                <label class="element-row_label"><span>Выберите расчет</span></label>
                <div class="element-row_fields">
                    <b-form-radio-group
                        v-model="data.build_rate.type"
                        @change="(value) => set_value('build_rate.type', value)"
                        :options="build_rate_type_options"
                        :disabled="!check_roles([ 'model' ]) || not_editable"
                    />
                </div>
            </div>

            <build_rate v-if="data.build_rate.type == 'Расчет нормы доходности'" :data="data.build_rate"
                v-on:set_value="(key, value) => set_value('build_rate.' + key, value)" :not_editable="not_editable"
            />

            <element_row v-if="data.build_rate.type == 'Данные Пользователя'"
                title="Норма доходности для инвестиций в строительство" :data="data.build_rate.custom"
                :validation="fields['build_rate.custom']" v-on:set_value="(key, value) => set_value(`build_rate.custom.${key}`, value)"
                :readonly="!check_roles([ 'model' ]) || not_editable"
            />
        </setup_frame>

        <inflation v-if="data"
            :id="id" :data="data.inflation"
            v-on:set_value="(value) => set_value('inflation', value)"
            v-on:need_refresh="() => $emit('need_refresh')"
            :not_editable="not_editable"
        />

        <setup_frame v-if="data" class="pb-5" title="Коэффициенты перехода">
            <element_row
                title="Коэффициент перехода от цен 1984 года к ценам на дату оценки" :data="data.coef_1984"
                :validation="fields['coef_1984']" v-on:set_value="(key, value) => set_value(`coef_1984.${key}`, value)"
                :readonly="!check_roles([ 'model' ]) || not_editable"
            />

			<!--
            <b-row class="mt-2 mx-0">

                <b-col cols="6" class="pl-0 d-flex justify-content-end">Коэффициент перехода от даты справочника к ценам на дату оценки</b-col>

                <b-col cols="3">
                    <b-form-input
                        :value="data.coef_current.value"
                        @change="(value) => set_value('coef_current.value', Number(value))"
                        placeholder="Значение" type="number"
                        :readonly="!check_roles([ 'model' ]) || not_editable"
                    />
                </b-col>

				<element_with_source :data="data.coef_current" :disabled="!check_roles([ 'model' ]) || not_editable" v-on:set_source="value => set_value('coef_current.source', value)" v-on:set_file="value => set_value('coef_current.file', value)"/>

			</b-row>
			-->
        </setup_frame>

    </setup_content>
</template>

<script>
import build_rate from './build_rate'
import inflation from './inflation'
import api from "../../../../../../api"
import setup_content from '../../setup_assets/content'
import setup_frame from '../../setup_assets/frame'
import element_row from "../../../../../widgets/element-row"

export default
{
    props :
    {
		id : String,
        data : Object,
        not_editable : Boolean,
    },

    components :
    {
        build_rate,
        inflation,
        setup_content,
        setup_frame,
        element_row
    },

    data()
    {
        return {
            build_rate_type_options : [ "Расчет нормы доходности", "Данные Пользователя" ],
            fields: {
                "build_rate.custom":
                {
                    check: (value) => api.check_number({ value : value, gte : 0, lte : 1 }),
                    msg: "От 0 до 1"
                },
                "coef_1984":
                {
                    check: (value) => api.check_number({ value : value, accuracy : 4, gt : 0 }),
                    msg: "Больше 0, до 4-х знаков после запятой",
                    gt_min : 0
                }
            }
        }
    },

    methods:
    {
        check_roles(roles)
        {
            return api.check_roles(this, roles)
        },

        go_back()
		{
			api.back.go(this)
		},
        
        set_value(key, value)
        {
            this.$emit("set_value", key, value)
        }
    },
}
</script>
